import { render, staticRenderFns } from "./CandidateProfileTalentfind.vue?vue&type=template&id=e1ff098c&scoped=true"
import script from "./CandidateProfileTalentfind.vue?vue&type=script&lang=js"
export * from "./CandidateProfileTalentfind.vue?vue&type=script&lang=js"
import style0 from "./CandidateProfileTalentfind.vue?vue&type=style&index=0&id=e1ff098c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ff098c",
  null
  
)

export default component.exports